import React from 'react';

import LoginRecordsLoader from './LoginRecordsLoader';
import Stack from '../../Shared/UI/Stack/components/Stack';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import LoginRecordsTable from './LoginRecordsTable';
import LoginRecordsPageController from './LoginRecordsPageController';

import styles from './LoginRecords.module.scss';

const LoginRecords = () => {
  return (
    <>
      <LoginRecordsLoader />
      <div className={styles.pageLayout}>
        <Stack gap="lg">
          <PageTitle text={'Login Records'} />
          <LoginRecordsTable />
          <LoginRecordsPageController />
        </Stack>
      </div>
    </>
  );
};

export default LoginRecords;
